export const translations = {
  'de': {
    'excursion_update_basket': 'Warenkorb aktualisieren',
    'excursion_error_no_adult_on_excursion': 'Kinder können nur in Begleitung eines Erwachsenen teilnehmen',
    'excursion_remove_from_basket': 'Aus Warenkorb entfernen',
    'excursion_add_to_basket': 'Zum Warenkorb hinzufügen',
    'excursion_choose_date_label': 'Bitte wählen Sie ein Ausflugsdatum, um Verfügbarkeit und Preise anzuzeigen',
    'please_select': 'Bitte auswählen',
    'excursion_no_available_dates': 'Keine verfügbaren Termine vorhanden',
    'excursion_who_is_traveling': 'Bitte wählen Sie die Teilnehmer aus',
    'total_price': 'Gesamtpreis',
    'excursion_amend_button': 'Ausflug ändern',
    'excursion_cost_label': 'Preis für den Ausflug',
    'basket_header': 'Warenkorb',
    'basket_empty': 'Es befinden sich keine Ausflüge in Ihrem Warenkorb',
    'return_to': 'Zurück zu',
    'home': 'Startseite',
    'cruises_overview_nights_on': 'Nächte auf',
    'show_prices_in': 'Preise anzeigen in',
    'day': 'Tag',
    'view_more': 'Mehr anzeigen',
    'basket': 'Warenkorb',
    'vod-language': 'Filmsprache wählen',
    'logout': 'Ausloggen',
    'book_now': 'Book Now',
    'itinerary_flight_number': 'Flugnummer',
    'choose_language_label': 'Sprache wählen',
    'location': 'Standort',
    'times': 'Öffnungszeiten',
    'elapsedTime': 'verstrichene Zeit',
    'time': 'Time',
    'hour': 'Stunde',
    'hours': 'Stunden',
    'more_details': 'Mehr Details',
    'per_adult': 'pro Person',
    'per_child': 'pro Kind',
    'port_from': 'Von',
    'ship_times_in_port': 'wo sich das Schiff im Hafen befindet',
    'points_of_interest': 'Sehenswürdigkeiten',
    'please_note': 'Bitte beachten',
    'book_experience': 'Erlebnis buchen',
    'duration': 'Dauer',
    'key_facts': 'Eckdaten',
    'about_the_experience': 'Was Sie Erleben',
    'on_the_way': 'unterwegs',
    'all': 'Alle',
    '2h_or_less': '2 Stunden oder weniger',
    '5h_or_more': '5 Stunden oder mehr',
    'experiences_from': 'Touren',
    'time_in_port': 'Zeit im Hafen',
    'experience_type': 'Erfahrungstyp',
    'filter_by': 'Filtern nach',
    'clear': 'klären',
    'contact_shore_ex_manager': 'contact_shore_ex_manager',
    'sold_out': 'Ausverkauft',
    'contact_team': 'Kontakt_an Bord_Team',
    'vod-language-set-to': 'Sie sehen sich derzeit VOD-Titel an, die in verfügbar sind',
    'select_pref_lang': 'Bitte wählen Sie aus den folgenden Optionen Ihre bevorzugte Sprache aus',
    'save': 'Speichern',
    'close': 'Schließen',
    'weather-at-sea': 'Wir sind heute auf See. Bitte versuchen Sie es wieder, wenn wir im Hafen sind',
    'weather_today': 'Heute',
    'weather_current_conditions': 'Aktuelle Bedingungen',
    'feelslike': 'Gefühlte T.',
    'humidity': 'Luftfeuchtigkeit',
    'wind': 'Wind',
    'weather_pressure': 'Luftdruck',
    'weather_forecast': 'Wettervorhersage',
    'weather_forecast_not_yet_available': 'Vorhersage noch nicht verfügbar',
    'synopsis': 'Wetterlage',
    'temperature': 'Temperatur',
    'feels_like': 'Gefühlte T.',
    'date': 'Datum',
    'arrives': 'Ankunft',
    'all_on_board': 'Alle an Bord',
    'departs': 'Abfahrt',
    'currency': 'Währung',
    'language': 'Sprache',
    'name_of_pier': 'Name des Hafens',
    'ships_local_agent': 'Lokaler Schiffsagent',
    'gangway': 'Steg',
    'weather_unavailable': 'Wetterinformationen sind derzeit nicht verfügbar',
    'all_aboard_times': 'Alle an Bord Zeiten',
    'port_information': 'Hafeninformationen',
    'no_activity_available': 'Entschuldigung, leider sind für diese Buchung/Unterkunft keine Ausflüge verfügbar',
    'no_activities_available': 'Entschuldigung, leider sind für diese Buchung/Unterkunft keine Ausflüge verfügbar',
    'number_of_persons': 'Number of Persons',
    'no_timeslots': 'No timeslots are available',
    'please_wait': 'Bitte auswählen',
    'book_not_complete': 'Booking not completed',
    'basket_accept_conditions': 'Allgemeine Geschäftsbedingungen akzeptieren',
    'book_success': 'successfully booked',
    'book_reference_info': 'Buchungsnummer',
    'book_additional_info': 'You can view this booking under ‘My Bookings’ on the Home Page',
    'basket_email_error': 'Bitte geben Sie ihre E-Mail-Adresse ein',
    'basket_email_missmatch': 'Die E-Mail-Adressen stimmen nicht überein',
    'basket_tc_error': 'Bitte akzeptieren Sie die unten aufgeführten Allgemeinen Geschäftsbedingungen',
    'basket_total_cost': 'Gesamtbetrag',
    'basket_contact_details': 'Kontaktdaten',
    'basket_email': 'E-Mail-Adresse',
    'basket_confirm_email': 'Bitte wiederholen Sie Ihre E-Mail-Adresse',
    'basket_mobile_number_label': 'Ihre Mobilfunknummer',
    'basket_mobile_number_tip': 'Bitte geben Sie eine Mobilfunknummer an, damit wir Sie erreichen können',
    'basket_payment_label': 'Zahlungsart',
    'basket_payment_card': 'Kreditkarte',
    'basket_payment_cash': 'Bar vor Ort',
    'basket_payment_tip': 'Bitte wählen Sie eine Zahlungsmethode aus',
    'basket_continue': 'Buchung fortsetzen',
    'confirmation_thank_you_card': 'Vielen Dank für Ihre Reservierung. Ein TUI Mitarbeiter wird Sie vor Ort kontaktieren um die Buchung zu bestätigen und die Kartenzahlung abzuwickeln',
    'confirmation_thank_you_cash': 'Vielen Dank für Ihre Reservierung. Ein TUI Mitarbeiter wird Sie vor Ort kontaktieren um die Buchung zu bestätigen und die Zahlung abzuwickeln',
    'confirmation_header': 'Reservierung getätigt',
    'confirmation_cruise_excursion_text': 'Vielen Dank für die Buchung Ihres Schiffsausfluges. Ihr Kreuzfahrtkonto wird automatisch mit dem angezeigten Preis belastet und die Tickets an Bord zur Verfügung gestellt',
    'confirmation_payment_method': 'Zahlungsart',
    'confirmation_booking_reference': 'Buchungsnummer',
    'confirmation_email': 'Bestätigungsmail',
    'confirmation_mobile_number': 'Mobilfunknummer',
    'confirmation_lead_passenger': 'Hauptpassagier',
    'confirmation_your_excursions': 'Ihre Ausflüge',
    'confirmation_total_cost': 'Gesamtkosten',
    'confirmation_my_excursions_pretext': 'Sie können alle Ihre Reservierungen jederzeit hier einsehen',
    'confirmation_my_excursions': 'Meine Ausflüge',
    'confirmation_excursion_cost': 'Gesamtkosten',
    'no_events': 'Aktuell sind keine weiteren Anlässe geplant',
    'placeholderKeyword': 'Suchbegriff',
    'searchNoResult': 'Leider wurden keine Resultate für Ihre Suche gefunden',
    'at_sea': 'auf See',
    'technical_data': 'Technische Daten',
    'timetable_start': 'Start',
    'timetable_end': 'Ende',
    'timetable_title': 'Bezeichnung',
    'timetable_deck': 'Deck',
    'timetable_category': 'Category',
    'timetable_location': 'Location',
    'meeting_time': 'Zeit',
    'departure_time': 'Abfahrtszeit',
    'experience': 'Ausflug',
    'bus_or_group': 'Bus-Nr.',
    'meeting_location': 'Treffpunkt',
    'port': 'Hafen',
    'arrival': 'Ankunft',
    'departure': 'Abfahrt',
    'no_whereandwhen': '',
    'whereandwhen_title': '',
    'whereandwhen_deck': '',
    'whereandwhen_times': '',
    'no_restaurants_available': 'Entschuldigung, leider sind für diese Buchung/Unterkunft keine Ausflüge verfügbar',
    'excursion_description_missing': 'Keine Beschreibung vorhanden',
    'excursion_check_availability_button': 'Bitte prüfen Sie hier die Verfügbarkeit',
    'excursion_reserve_button': 'Ausflug reservieren',
    'excursion_available_on_label': 'Buchbare Tage',
    'excursion_price_label': 'Preis',
    'excursion_basket_updated': 'Warenkorb aktualisiert',
    'excursion_go_to_basket_button': 'Weiter zum Warenkorb',
    'excursion_highlights_label': 'Highlights',
    'excursion_included_label': 'Inbegriffen',
    'excursion_important_information_label': 'Wichtig zu wissen',
    'no_excursions_available': 'Entschuldigung, leider sind für diese Buchung/Unterkunft keine Ausflüge verfügbar',
    'pax_select_error': 'Sie müssen mindestens einen Passagier auswählen.',
    'experience_already_booked': 'Bereits gebucht',
    'hub_book_experience_error': 'Die Buchung kann nicht abgeschlossen werden. Bitte wenden Sie sich an das zuständige Bordteam.',
    'your_experience': 'Ihre Erfahrung',
    'is_successfully_booked': 'ist_erfolgreich_gebucht',
    'my_bookings': 'Meine Buchungen',
    'overbooked': 'Zu viele Passagiere ausgewählt',
    'slots_remaining': 'verbleibende Slots',
    'participants_checkbox': 'Teilnehmer_Kontrollkästchen',
    'no_experiences_available': 'Es sind keine Erlebnisse verfügbar. Bitte wenden Sie sich an Destination Services',
    'my_excursions_header': 'Meine Ausflüge',
    'my_excursions_no_excursions': 'Für diese Buchung wurden keine Ausflüge gebucht',
    'my_excursions_date': 'Datum',
    'my_excursions_title': 'Titel',
    'my_excursions_cost': 'Kosten',
    'tile_my_holiday': 'Mein Urlaub',
    'tile_browse_all_excursions': 'Alle Ausflüge',
    'itineraryTitle': 'Ihr Hotel',
    'tile_itinerary': 'Buchungsübersicht',
    'tile_cruise_excursions': 'Schiffsexkursionen',
    'tile_resort_excursions': 'Hotelexkursionen',
    'tile_my_excursions': 'Meine Ausflüge',
    'no_onboard_bookings': '',
    'confirmed': 'Reservierung getätigt',
    'waitlist': 'Favoriten',
    'cancelled': '',
    'onboard_bookings_title': '',
    'from_time': '',
    'to_time': '',
    'description': '',
    'excursion_code': 'Preis für den Ausflug',
    'view_experiences': 'Erlebnisse ansehen',
    'filters': 'Filter',
    'no_events_match_filters': 'Keine Ereignisse entsprechen den Filtern',
    'please_change_filters': 'Bitte ändern oder löschen Sie die Filter',
    'search': 'Suchen',
    'search_events': 'Veranstaltungen suchen',
    'clear_filters': 'Filter löschen',
    'daily_programme': 'Tagesprogramm',
    'hf_login_first_name': 'Bitte geben Sie den Vorname des Reiseteilnehmers ein, welcher die Buchung getätigt hat',
    'hf_login_last_name': 'Bitte geben Sie den Nachnamen des Reiseteilnehmers ein, welcher die Buchung getätigt hat',
    'hf_login_dob': 'Geburtsdatum',
    'login_date_error': 'Bitte Datum eingeben',
    'login_booking_reference_error': 'Bitte geben Sie Ihre Buchungsnummer ein',
    'login_last_name_error': 'Bitte geben Sie den Nachnamen des Reiseteilnehmers ein, welcher die Buchung getätigt hat',
    'reLoginMessageRetina': '',
    'click_here': '',
    'configuration_missing': 'Bestätigungsmail',
    'accessApplication': 'Bitte loggen Sie sich ein',
    'departureDate': 'Reisedatum',
    'bookingReference': 'Buchungsnummer',
    'leadPassengerSurname': 'Nachname',
    'placeholderLastname': 'NACHNAME',
    'login': 'Login',
    'loginFailed': 'Login fehlgeschlagen, bitte die eingegebenen Daten überprüfen',
    'login_by_scan': 'Bitte melden Sie sich an, indem Sie Ihre Karte scannen',
    'step': 'Schritt',
    'find_barcode': 'Finden Sie den Barcode auf Ihrer Schiffskarte',
    'scan_barcode': 'Barcode scannen',
    'return_to_home': 'Zurück zur Startseite',
    'error_empty_fields': 'Bitte achten Sie darauf, alle Felder auszufüllen.',
    'account_nr': 'Kontonummer',
    'cabin_nr': 'Kabinennummer',
    'pin_nr': 'Pin Nummer',
    'change_pin': 'pin ändern',
    'new_pin': 'neuer_Pin',
    'pin_length_error': 'Pinlängenfehler',
    'pin_change_info': 'Sie können Ihre PIN-Nummer jederzeit unter „Mein Konto“ ändern oder zurücksetzen.',
    'new_pin_length': 'neue_pin_länge',
    'error_pin_change': 'Fehler bei der PIN-Änderung',
    'confirm': 'konfirmieren',
    'back': 'zurücksetzen',
    'loginFailedRetina': 'Login fehlgeschlagen, bitte die eingegebenen Daten überprüfen',
    'login_success': '',
    'redirect_dashboard': '',
    'redirect_click_dashboard': '',
    'disableautocentering': 'Automatische Zentrierung deaktivieren',
    'hideweather': 'Wetter Ausblenden',
    'hide_ship_names': 'Schiffsnamen ausblenden',
    'hide_fleet': 'Flotte verstecken',
    'no_gps_data': 'Die GPS-Daten konnten nicht abgerufen werden.',
    'tracker': 'Schiffsposition',
    'selected_ship': 'Ausgewähltes Schiff',
    'trackerweatherheading': 'Aktuelles Wetter',
    'musement_activity_duration': '',
    'musement_activity_price': '',
    'musement_activity_from': '',
    'musement_activity_language': '',
    'musement_activity_languages': '',
    'musement_activity_do_this_because': '',
    'musement_activity_what_to_expect': '',
    'musement_activity_where': '',
    'musement_activity_meeting_point': '',
    'musement_activity_what_is_included': '',
    'musement_activity_what_is_not_included': '',
    'musement_activity_what_to_remember': '',
    'other_currencies_available': 'Andere Zahlungswährungen sind verfügbar. Bitte beachten Sie, dass die gewählte Zahlungswährung nach der Bezahlung an Bord nicht mehr geändert werden kann.',
    'total_charges': 'Summe',
    'department': 'Abteilung',
    'charges': 'Preis',
    'no_charges': 'Derzeit keine Einträge',
    'discount': 'Ermässigung',
    'problem_cabin_label': '',
    'problem_category_label': '',
    'problem_description_label': '',
    'problem_description_placeholder': '',
    'problem_submit_label': '',
    'tile_add_problem': '',
    'tile_problem_tracking': '',
    'feedback_thank_you_message': 'Vielen Dank für Ihr Feedback',
    'submitFeedback': 'Feedback absenden',
    'feedback_error_message': 'Das Feedback kann nicht beendet werden, bitte kontaktieren Sie Ihren Ansprechpartner',
    'feedback_termsandconditions_must_be_accepted': '',
    'yes': 'Ja',
    'no': 'Nein',
    'mandatory_answer': '',
    'feedback_please_select': 'Bitte wählen Sie',
    'feedback_textarea_placeholder': 'Maximal 250 Zeichen',
    'feedback_textinput_placeholder': '',
    'seanet_vod_fetch_error': 'Es konnten keine VOD-Titel in der von Ihnen ausgewählten Sprache gefunden werden.',
    'retry_all_languages': 'Alle Sprachen erneut versuchen',
    'genres': 'Genres',
    'error_fetching_content': 'Fehler beim Abrufen des Inhalts',
    'play': 'Abspielen',
    'run_time': 'Laufzeit',
    'summary': 'Beschreibung',
    'actors': 'Schauspieler',
    'directed_by': 'Geleitet von',
    'no_spa_available': 'Entschuldigung, leider sind für diese Buchung/Unterkunft keine Ausflüge verfügbar',
    'spa_justtoknow': 'Just So You Know',
    'spa_price': 'Gesamtpreis',
    'spa_duration': 'Duration',
    'watchlistAdd': 'zu Favoriten hinzufügen',
    'watchlist': 'Favoriten',
    'movies': 'Spielfilme',
    'series': 'Serien',
    'weather-not-available': 'Leider konnte das Wetter nicht abgerufen werden',
    'weather_future_destinations_soon': 'Vorhersage für zukünftige Ziele ist in Kürze verfügbar',
    'monday': 'Montag',
    'tuesday': 'Dienstag',
    'wednesday': 'Mittwoch',
    'thursday': 'Donnerstag',
    'friday': 'Freitag',
    'saturday': 'Samstag',
    'sunday': 'Sonntag',
    'child': 'Kind',
    'adult': 'Erwachsene',
    'passenger_status_MinimumAge': 'Mindestalter unterschritten',
    'passenger_status_MaximumAge': 'Höchstalter überschritten',
    'passenger_status_AlreadyBooked': 'Bereits reserviert',
    'passenger_status_LastCruiseDay': 'Letzter Tag an Bord',
    'passenger_status_FirstCruiseDay': 'Erster Tag an Bord',
    'passenger_status_NoPriceAvailable': 'Kein Preis verfügbar',
    'passenger_status_TimeOverlapWithOtherBooking': 'Zeitüberschneidung mit anderer Reservierung',
    'passenger_status_TimeOverlapWithOtherCartEntry': 'Zeitüberschneidung mit anderen Reservierung im Warenkorb',
  },
  'options': {
  },
  'en': {
    'excursion_update_basket': 'Update basket',
    'excursion_error_no_adult_on_excursion': 'Adults must accompany Children/Infant',
    'excursion_remove_from_basket': 'Remove from basket',
    'excursion_add_to_basket': 'Add to basket',
    'excursion_choose_date_label': 'Choose a date to get passenger availability and prices',
    'please_select': 'Please select',
    'excursion_no_available_dates': 'We are sorry. There are no available dates for this excursion for your booking',
    'excursion_who_is_traveling': 'Who\'s travelling on the excursion?',
    'total_price': 'Total price',
    'excursion_amend_button': 'Amend excursion',
    'excursion_cost_label': 'Excursion cost:',
    'basket_header': 'Basket',
    'basket_empty': 'There are no excursions in your basket.',
    'return_to': 'Return to',
    'home': 'Home',
    'cruises_overview_nights_on': 'nights on',
    'show_prices_in': 'Show Prices In',
    'day': 'Day',
    'view_more': 'View More',
    'basket': 'Basket',
    'vod-language': 'VOD Language',
    'logout': 'Sign out',
    'book_now': 'Book Now',
    'itinerary_flight_number': 'Flight no:',
    'choose_language_label': 'Choose language:',
    'location': 'Location',
    'times': 'Times',
    'elapsedTime': 'Time played',
    'time': 'Time',
    'hour': 'hours',
    'hours': 'hours',
    'more_details': 'More Details',
    'per_adult': 'per adult',
    'per_child': 'per child',
    'port_from': 'From',
    'ship_times_in_port': ' where the ship is in port',
    'points_of_interest': 'Points of interest',
    'please_note': 'Please Note',
    'book_experience': 'Book Experience',
    'duration': 'Duration',
    'key_facts': 'Key Facts',
    'about_the_experience': 'About the Experience',
    'on_the_way': 'On the way',
    'all': 'All',
    '2h_or_less': '2h or less',
    '5h_or_more': '5h or more',
    'experiences_from': 'Experiences from',
    'time_in_port': 'Time in port',
    'experience_type': 'Experience type',
    'filter_by': 'Filter by',
    'clear': 'Clear',
    'contact_shore_ex_manager': 'Please see onboard Shore Ex Manager',
    'sold_out': 'Sold Out',
    'contact_team': 'Contact the onboard team for latest availability',
    'vod-language-set-to': 'You are currently viewing VOD titles available in',
    'select_pref_lang': 'Please select your preferred language from the following options',
    'save': 'Save',
    'close': 'Close',
    'weather-at-sea': 'We are at sea.',
    'weather_today': 'Today',
    'weather_current_conditions': 'Current Conditions',
    'feelslike': 'Feels Like',
    'humidity': 'Humidity',
    'wind': 'Wind',
    'weather_pressure': 'Pressure',
    'weather_forecast': 'Weather Forecast',
    'weather_forecast_not_yet_available': 'Forecast not yet available',
    'synopsis': 'Synopsis',
    'temperature': 'Temperature',
    'feels_like': 'Feels Like',
    'date': 'Date',
    'arrives': 'Arrives',
    'all_on_board': 'All Onboard',
    'departs': 'Departs',
    'currency': 'Currency',
    'language': 'Language',
    'name_of_pier': 'Name of Pier',
    'ships_local_agent': 'Ship\'s Local Agent',
    'gangway': 'Gangway',
    'weather_unavailable': 'Weather information is not currently available',
    'all_aboard_times': 'All Onboard',
    'port_information': 'Important information',
    'no_activity_available': 'We are sorry, there are no activities available',
    'no_activities_available': 'No activities available',
    'number_of_persons': 'Number of Persons',
    'no_timeslots': 'Sorry, there are no timeslots available for the selected day, please contact the relevant ship team.',
    'please_wait': 'Please wait…',
    'book_not_complete': 'The booking cannot be completed, please contact the relevant team',
    'basket_accept_conditions': 'Accept Conditions',
    'book_success': 'successfully booked',
    'book_reference_info': 'Your booking reference number is ',
    'book_additional_info': 'You can view this booking under ‘My Bookings’ on the Home Page.',
    'basket_email_error': 'Please enter your email address',
    'basket_email_missmatch': 'Email addresses must match',
    'basket_tc_error': 'Please accept the Terms & Conditions which are listed below, to continue',
    'basket_total_cost': 'Total cost:',
    'basket_contact_details': 'Contact Details',
    'basket_email': 'Email address:',
    'basket_confirm_email': 'Confirm email address:',
    'basket_mobile_number_label': 'Mobile number:',
    'basket_mobile_number_tip': 'Please enter a mobile number if you have one so we can keep you informed whilst you are on holiday',
    'basket_payment_label': 'Please select your preferred payment method:',
    'basket_payment_card': 'Card',
    'basket_payment_cash': 'Cash',
    'basket_payment_tip': 'This will help when we contact you to complete your reservation',
    'basket_continue': 'Continue',
    'confirmation_thank_you_card': 'Thank you for reserving your excursion. We will phone you 4hrs after your arrival (between 09:00 and 20:00) to confirm your booking and take payment.',
    'confirmation_thank_you_cash': 'Thank you for reserving your excursion. Your TUI rep will make contact once in resort to confirm your booking and take cash payment.',
    'confirmation_header': 'All reserved!',
    'confirmation_cruise_excursion_text': 'Thank you for booking your cruise excursion. Your cruise account will be automatically debited with the price shown, and tickets will be provided on-board your ship.',
    'confirmation_payment_method': 'Payment method:',
    'confirmation_booking_reference': 'Booking reference:',
    'confirmation_email': 'Email:',
    'confirmation_mobile_number': 'Mobile number:',
    'confirmation_lead_passenger': 'Lead passenger:',
    'confirmation_your_excursions': 'Your Excursions',
    'confirmation_total_cost': 'Total cost:',
    'confirmation_my_excursions_pretext': 'You can see all your reservations at any time under',
    'confirmation_my_excursions': 'My Excursions',
    'confirmation_excursion_cost': 'Excursion cost:',
    'no_events': 'No Events found',
    'placeholderKeyword': 'Keyword',
    'searchNoResult': 'Sorry, but we don\'t have any results for your search',
    'at_sea': 'at sea',
    'technical_data': 'Technical Data',
    'timetable_start': 'Start',
    'timetable_end': 'End',
    'timetable_title': 'Title',
    'timetable_deck': 'Location',
    'timetable_category': 'Category',
    'timetable_location': 'Location Info',
    'meeting_time': 'Meeting Time',
    'departure_time': 'Departure Time ',
    'experience': 'Experience',
    'bus_or_group': 'Bus/Group',
    'meeting_location': 'Meeting Location',
    'port': 'Port',
    'arrival': 'Arrival',
    'departure': 'Departure',
    'no_whereandwhen': 'No Venues found',
    'whereandwhen_title': 'Venue',
    'whereandwhen_deck': 'Deck',
    'whereandwhen_times': 'Times',
    'no_restaurants_available': 'We are sorry, there are no restaurants available',
    'excursion_description_missing': 'Description missing',
    'excursion_check_availability_button': 'Check availability - log in',
    'excursion_reserve_button': 'Reserve excursion',
    'excursion_available_on_label': 'Available on:',
    'excursion_price_label': 'Price: ',
    'excursion_basket_updated': 'Your basket was updated',
    'excursion_go_to_basket_button': 'Continue to basket',
    'excursion_highlights_label': 'Highlights',
    'excursion_included_label': 'Included',
    'excursion_important_information_label': 'Important information',
    'no_excursions_available': 'We are sorry there are no excursions available for this booking/resort',
    'pax_select_error': 'You need to select at least one passenger.',
    'experience_already_booked': 'Already Booked',
    'hub_book_experience_error': 'The booking cannot be completed. Please contact the relevant onboard team.',
    'your_experience': 'Your experience',
    'is_successfully_booked': 'is successfully booked.',
    'my_bookings': 'My Bookings',
    'overbooked': 'Too many passengers selected',
    'slots_remaining': 'Available slots remaining',
    'participants_checkbox': 'Please use the checkbox to select or unselect participants for',
    'no_experiences_available': 'No experiences available, please contact Destination Services',
    'my_excursions_header': 'My Excursions',
    'my_excursions_no_excursions': 'There are no excursions reserved for this booking.',
    'my_excursions_date': 'Date',
    'my_excursions_title': 'Title',
    'my_excursions_cost': 'Cost',
    'tile_my_holiday': 'My Holiday',
    'tile_browse_all_excursions': 'Browse all excursions',
    'itineraryTitle': 'Your Holiday',
    'tile_itinerary': 'Itinerary',
    'tile_cruise_excursions': 'Cruise Excursions',
    'tile_resort_excursions': 'Resort Excursions',
    'tile_my_excursions': 'My Excursions',
    'no_onboard_bookings': 'There are currently no bookings for your account',
    'confirmed': 'Confirmed',
    'waitlist': 'Waitlist',
    'cancelled': 'Cancelled',
    'onboard_bookings_title': 'Your bookings',
    'from_time': 'From time',
    'to_time': 'To time',
    'description': 'Description',
    'excursion_code': 'Experience code',
    'view_experiences': 'View Experiences',
    'filters': 'Filters',
    'no_events_match_filters': 'No events match the filters',
    'please_change_filters': 'Please change or clear the filters in order to see the events',
    'search': 'Search',
    'search_events': 'Search Events',
    'clear_filters': 'Clear Filters',
    'daily_programme': 'Daily Programme',
    'hf_login_first_name': 'First name',
    'hf_login_last_name': 'Last name',
    'hf_login_dob': 'Date of birth',
    'login_date_error': 'Please enter date',
    'login_booking_reference_error': 'Please enter your booking reference',
    'login_last_name_error': 'Please enter the surname of the passenger who received the confirmation email',
    'reLoginMessageRetina': 'You are currently logged out of Navigate and need to log in to continue. Please use the link to go to the status/login page.',
    'click_here': 'click here',
    'configuration_missing': 'Configuration missing, please inform the staff about this.',
    'accessApplication': 'Please login',
    'departureDate': 'Departure date',
    'bookingReference': 'Booking Reference',
    'leadPassengerSurname': 'Lead passenger surname',
    'placeholderLastname': 'SURNAME',
    'login': 'Login',
    'loginFailed': 'Login failed, please check your data and try again',
    'login_by_scan': 'Please log in by scanning your card to continue',
    'step': 'Step',
    'find_barcode': 'Find the barcode on your ship card',
    'scan_barcode': 'Scan it below the screen',
    'return_to_home': 'Return To Home',
    'error_empty_fields': 'Please make sure to fill out all the fields.',
    'account_nr': 'Account Number',
    'cabin_nr': 'Cabin Number',
    'pin_nr': 'PIN Number',
    'change_pin': 'Change your PIN number to continue',
    'new_pin': 'Your new PIN Number',
    'pin_length_error': 'Your PIN number needs to be 4 digits long',
    'pin_change_info': 'You can change or reset your PIN number at any time by visiting My Account.',
    'new_pin_length': 'Please make sure your new pin is 4 digits.',
    'error_pin_change': 'There has been an error with changing your PIN.',
    'confirm': 'Confirm',
    'back': 'Back',
    'loginFailedRetina': 'Login failed, please visit the reception',
    'login_success': 'You are now logged in as: ',
    'redirect_dashboard': 'The page will redirect to navigate dashboard in ',
    'redirect_click_dashboard': 'If the redirect does not happen automatically, please',
    'disableautocentering': 'Disable Auto Centering',
    'hideweather': 'Hide Weather',
    'hide_ship_names': 'Hide Ship Names',
    'hide_fleet': 'Hide Fleet',
    'no_gps_data': 'GPS data could not be retrieved.',
    'tracker': 'Ship Tracker',
    'selected_ship': 'Selected Ship',
    'trackerweatherheading': 'Current Weather',
    'musement_activity_duration': 'Duration:',
    'musement_activity_price': 'Price:',
    'musement_activity_from': 'from',
    'musement_activity_language': 'Language:',
    'musement_activity_languages': 'Languages:',
    'musement_activity_do_this_because': 'Do This Because',
    'musement_activity_what_to_expect': 'What To Expect',
    'musement_activity_where': 'Where',
    'musement_activity_meeting_point': 'Meeting Point:',
    'musement_activity_what_is_included': 'What\'s Included',
    'musement_activity_what_is_not_included': 'What\'s Not Included',
    'musement_activity_what_to_remember': 'What To Remember',
    'other_currencies_available': 'Other settlement currencies are available. Please note, once you have settled any payments on board, your chosen settlement currency cannot be changed.',
    'total_charges': 'Total charges',
    'department': 'Department',
    'charges': 'Charges',
    'no_charges': 'There are currently no charges to your account',
    'discount': 'Discount',
    'problem_cabin_label': 'Cabin:',
    'problem_category_label': 'Problem Category:',
    'problem_description_label': 'Problem Description:',
    'problem_description_placeholder': 'Describe problem here',
    'problem_submit_label': 'Submit Problem',
    'tile_add_problem': 'Report A Problem',
    'tile_problem_tracking': 'Problem Tracking',
    'feedback_thank_you_message': 'Thank you for taking the time to provide feedback.',
    'submitFeedback': 'Submit',
    'feedback_error_message': 'The feedback cannot be completed, please contact the relevant team',
    'feedback_termsandconditions_must_be_accepted': 'Please accept the terms and conditions in order to submit the data.',
    'yes': 'Yes',
    'no': 'No',
    'mandatory_answer': 'This field is mandatory',
    'feedback_please_select': 'Please select',
    'feedback_textarea_placeholder': '250 characters limit',
    'feedback_textinput_placeholder': '50 characters limit',
    'seanet_vod_fetch_error': 'No VOD titles in your selected language could be found.',
    'retry_all_languages': 'Retry All Languages',
    'genres': 'Genres',
    'error_fetching_content': 'Error fetching content',
    'play': 'Play',
    'run_time': 'Run Time',
    'summary': 'Summary',
    'actors': 'Actors',
    'directed_by': 'Directed By',
    'no_spa_available': 'We are sorry there are no spa treatments available',
    'spa_justtoknow': 'Just So You Know',
    'spa_price': 'Price',
    'spa_duration': 'Duration',
    'watchlistAdd': 'Add to watchlist',
    'watchlist': 'Watchlist',
    'movies': 'Movies',
    'series': 'Box Sets',
    'weather-not-available': 'Sorry, weather could not be retrieved',
    'weather_future_destinations_soon': 'Forecast for future destinations will be available soon',
    'monday': 'Monday',
    'tuesday': 'Tuesday',
    'wednesday': 'Wednesday',
    'thursday': 'Thursday',
    'friday': 'Friday',
    'saturday': 'Saturday',
    'sunday': 'Sunday',
    'child': 'Child',
    'adult': 'Adult',
    'passenger_status_MinimumAge': 'Person is under minimum age',
    'passenger_status_MaximumAge': 'Person is over maximum age',
    'passenger_status_AlreadyBooked': 'Already booked',
    'passenger_status_LastCruiseDay': 'Last day of the cruise',
    'passenger_status_FirstCruiseDay': 'First day of the cruise',
    'passenger_status_NoPriceAvailable': 'No price available',
    'passenger_status_TimeOverlapWithOtherBooking': 'Time overlap with another booking',
    'passenger_status_TimeOverlapWithOtherCartEntry': 'Time overlap with another planner entry',
  },
  'fr': {
    'excursion_update_basket': 'Mise à jour du panier',
    'excursion_error_no_adult_on_excursion': 'Les adultes doivent accompagner leurs enfants',
    'excursion_remove_from_basket': 'Retirer du panier',
    'excursion_add_to_basket': 'Ajouter au panier',
    'excursion_choose_date_label': 'Choisissez une date afin d’afficher les disponibilités et les tarifs',
    'please_select': 'Veuillez sélectionner',
    'excursion_no_available_dates': 'Désolé, cette excursion n’est pas disponible aux dates de votre réservation.',
    'excursion_who_is_traveling': 'Qui participe à l\'excursion ?',
    'total_price': 'Prix total',
    'excursion_amend_button': 'Modifier une excursion',
    'excursion_cost_label': 'Prix de l\'excursion :',
    'basket_header': 'Panier',
    'basket_empty': 'Il n\'y a pas d\'excursion dans votre panier.',
    'return_to': 'Retour à',
    'home': 'accueil',
    'cruises_overview_nights_on': 'nuits à bord',
    'show_prices_in': 'Afficher les prix en',
    'day': 'Jour',
    'view_more': 'Voir plus',
    'basket': 'Panier',
    'vod-language': 'Langue de la VOD',
    'logout': 'se déconnecter',
    'book_now': 'Réserve',
    'itinerary_flight_number': 'Numéro de vol :',
    'choose_language_label': 'Choisissez une langue :',
    'location': 'localisation',
    'times': 'heures',
    'elapsedTime': 'Temps écoulé',
    'time': 'heure',
    'hour': 'heure',
    'hours': 'heures',
    'more_details': 'Plus de détails',
    'per_adult': 'par adulte',
    'per_child': 'par enfant',
    'port_from': 'Depuis',
    'ship_times_in_port': 'lorsque le navire est au port',
    'points_of_interest': 'Points d\'intérêt',
    'please_note': 'Veuillez noter',
    'book_experience': 'Réserver l’expérience',
    'duration': 'Durée',
    'key_facts': 'Informations clés',
    'about_the_experience': 'A propos de l\'expérience',
    'on_the_way': 'En route',
    'all': 'Tous',
    '2h_or_less': '2h ou moins',
    '5h_or_more': '5h ou plus',
    'experiences_from': 'Expérience à',
    'time_in_port': 'Temps à quai',
    'experience_type': 'Type d’expérience',
    'filter_by': 'Filtrer par',
    'clear': 'Réinitialiser',
    'contact_shore_ex_manager': '',
    'sold_out': 'Complet',
    'contact_team': 'Contactez l’équipe à bord pour connaître les dernières disponibilités',
    'vod-language-set-to': 'Vous êtes actuellement en train de regarder les titres VOD disponibles dans',
    'select_pref_lang': 'Veuillez sélectionner la langue de votre choix parmi les options suivantes',
    'save': 'sauvegarder',
    'close': 'Fermer',
    'weather-at-sea': 'météo en mer',
    'weather_today': 'Aujjourd’hui',
    'weather_current_conditions': 'Conditions Actuelles',
    'feelslike': 'Température',
    'humidity': 'humidité',
    'wind': 'vent',
    'weather_pressure': 'Pression',
    'weather_forecast': 'météo en mer',
    'weather_forecast_not_yet_available': 'Prévisions Météo',
    'synopsis': 'Résumé',
    'temperature': 'température',
    'feels_like': 'Température',
    'date': 'Date',
    'arrives': 'Arrive',
    'all_on_board': 'Tous à bord',
    'departs': 'Part',
    'currency': 'Devise',
    'language': 'langue',
    'name_of_pier': 'Nom du quai',
    'ships_local_agent': 'Agent local du navire',
    'gangway': 'passerelle',
    'weather_unavailable': 'Informations météo actuellement indisponibles',
    'all_aboard_times': 'Horaires du Tous à Bord',
    'port_information': 'Information importante',
    'no_activity_available': 'Désolé, il n\'y a aucune activité de disponible',
    'no_activities_available': 'Aucune activité disponible',
    'number_of_persons': 'Nombre de personnes',
    'no_timeslots': 'Désolé, aucun créneau horaire n’est disponible pour le jour sélectionné. Veuillez contacter l’équipe concernée à bord du navire.',
    'please_wait': 'Merci de patienter...',
    'book_not_complete': 'La réservation ne peut être effectuée, veuillez nous contacter. ',
    'basket_accept_conditions': 'Accepter les conditions ',
    'book_success': 'réservation réussie',
    'book_reference_info': 'Votre référence de réservation est :',
    'book_additional_info': 'Vous pouvez consulter cette réservation via « Mes Réservations » sur la page d\'accueil.',
    'basket_email_error': 'Merci d\'indiquer votre adresse mail',
    'basket_email_missmatch': 'Les adresses mail doivent être identiques',
    'basket_tc_error': 'Merci d\'accepter les conditions générales ci-dessous avant de continuer ',
    'basket_total_cost': 'Prix total :',
    'basket_contact_details': 'Informations de contact',
    'basket_email': 'Adresse mail :',
    'basket_confirm_email': 'Confirmer l\'adresse mail:',
    'basket_mobile_number_label': 'Numéro de téléphone portable :',
    'basket_mobile_number_tip': 'Veuillez indiquer votre numéro de téléphone portable si vous en avez un afin que nous puissions vous joindre pendant vos vacances au besoin.',
    'basket_payment_label': 'Merci de sélectionner le moyen de paiement souhaité :',
    'basket_payment_card': 'Carte bancaire',
    'basket_payment_cash': 'Espèces',
    'basket_payment_tip': 'Cela nous aidera si nous devons vous contacter pour compléter votre réservation.',
    'basket_continue': 'Continuer',
    'confirmation_thank_you_card': 'Merci d\'avoir réservé votre excursion. Nous vous téléphonerons 4 heures après votre arrivée (entre 09:00 et 20:00) pour confirmer votre réservation et encaisser le paiement.',
    'confirmation_thank_you_cash': 'Merci d\'avoir réservé votre excursion. Votre représentant vous contactera une fois sur place pour confirmer votre réservation et encaisser votre paiement.',
    'confirmation_header': 'Réservation confirmée !',
    'confirmation_cruise_excursion_text': 'Merci pour la réservation de votre excursion. Votre compte à bord sera automatiquement débité du prix indiqué et les billets vous seront remis à bord du navire.',
    'confirmation_payment_method': 'Moyen de paiement :',
    'confirmation_booking_reference': 'Référence de réservation : ',
    'confirmation_email': 'Email : ',
    'confirmation_mobile_number': 'Numéro de téléphone portable :',
    'confirmation_lead_passenger': 'Passager principal :',
    'confirmation_your_excursions': 'Vos excursions',
    'confirmation_total_cost': 'Prix total :',
    'confirmation_my_excursions_pretext': 'Vous pouvez consulter vos réservations à tout moment sous la rubrique',
    'confirmation_my_excursions': 'Mes excursions',
    'confirmation_excursion_cost': 'Prix de l\'excursion :',
    'no_events': 'Aucun événement trouvé',
    'placeholderKeyword': 'Mot clé',
    'searchNoResult': 'Désolé, mais nous n\'avons pas de résultats pour votre recherche.',
    'at_sea': 'en mer',
    'technical_data': 'Donnée technique',
    'timetable_start': 'Début',
    'timetable_end': 'Fin',
    'timetable_title': 'Titre',
    'timetable_deck': 'Localisation',
    'timetable_category': 'Catégorie',
    'timetable_location': 'Info de localisation',
    'meeting_time': 'Heure de rendez-vous',
    'departure_time': 'Heure de départ',
    'experience': 'expérience',
    'bus_or_group': 'Bus / Groupe',
    'meeting_location': 'Lieu de rendez-vous',
    'port': 'port',
    'arrival': 'Arrivée',
    'departure': 'Départ',
    'no_whereandwhen': 'Aucun lieu trouvé',
    'whereandwhen_title': 'Lieu, date et horaires',
    'whereandwhen_deck': 'Pont',
    'whereandwhen_times': 'Horaires',
    'no_restaurants_available': 'Désolé, aucun restaurant n\'est disponible',
    'excursion_description_missing': 'Description manquante',
    'excursion_check_availability_button': 'Vérifier la disponibilité - Connectez vous ',
    'excursion_reserve_button': 'Réserver l\'excursion',
    'excursion_available_on_label': 'Disponible sur :',
    'excursion_price_label': 'Prix :',
    'excursion_basket_updated': 'Votre panier a été mis à jour',
    'excursion_go_to_basket_button': 'Continuer vers le panier',
    'excursion_highlights_label': 'Points d\'intérêt',
    'excursion_included_label': 'Inclus',
    'excursion_important_information_label': 'Information importante',
    'no_excursions_available': 'Désolé, il n’y a pas d’excursions disponibles pour cette réservation',
    'pax_select_error': 'Vous devez sélectionner au moins un passager.',
    'experience_already_booked': 'Déjà réservé',
    'hub_book_experience_error': 'La réservation ne peut pas être finalisée. Veuillez contacter l’équipe à bord concernée.',
    'your_experience': 'Votre expérience',
    'is_successfully_booked': 'est réservée avec succès.',
    'my_bookings': 'Mes réservations',
    'overbooked': 'Trop de passagers sélectionnés',
    'slots_remaining': 'Créneaux disponibles restants',
    'participants_checkbox': 'Veuillez utiliser la case à cocher pour sélectionner ou désélectionner les participants pour',
    'no_experiences_available': 'Aucune excursion disponible, veuillez contacter le service dédié',
    'my_excursions_header': 'Mes excursions',
    'my_excursions_no_excursions': 'Aucune excursion réservée pour ce dossier',
    'my_excursions_date': 'Date',
    'my_excursions_title': 'Titre',
    'my_excursions_cost': 'Prix',
    'tile_my_holiday': 'Mes vacances',
    'tile_browse_all_excursions': 'Parcourir toutes les excursions',
    'itineraryTitle': 'Vos vacances',
    'tile_itinerary': 'Itinéraire',
    'tile_cruise_excursions': 'Excursions de croisière',
    'tile_resort_excursions': 'Titre de l\'excursion',
    'tile_my_excursions': 'Mes excursions',
    'no_onboard_bookings': 'Il n\'y a aucune réservation en cours sur votre compte',
    'confirmed': 'Confirmé',
    'waitlist': 'Liste d\'attente',
    'cancelled': 'Annulé',
    'onboard_bookings_title': 'Vos réservations',
    'from_time': 'À partir de',
    'to_time': 'Jusqu\'à',
    'description': 'Description',
    'excursion_code': 'Code excursion',
    'view_experiences': 'Voir les expériences',
    'filters': 'Filtres',
    'no_events_match_filters': 'Aucun événement ne correspond aux filtres',
    'please_change_filters': 'Veuillez modifier ou effacer les filtres pour voir les événements',
    'search': 'Recherche',
    'search_events': 'Rechercher des événements',
    'clear_filters': 'Effacer les filtres',
    'daily_programme': 'Programme Quotidien',
    'hf_login_first_name': 'Prénom',
    'hf_login_last_name': 'Nom de famille',
    'hf_login_dob': 'Date de naissance',
    'login_date_error': 'Merci d\'indiquer la date',
    'login_booking_reference_error': 'Merci d\'indiquer votre référence de réservation',
    'login_last_name_error': 'Merci d\'indiquer le nom du passager ayant reçu le mail de confirmation',
    'reLoginMessageRetina': 'Vous êtes actuellement déconnecté. Veuillez vous reconnecter en utilisant le lien vers la page de connexion.',
    'click_here': 'Cliquez ici',
    'configuration_missing': 'La configuration est manquante, merci d\'en informer le personnel.',
    'accessApplication': 'Identifiez-vous',
    'departureDate': 'Date de départ',
    'bookingReference': 'Référence de réservation',
    'leadPassengerSurname': 'Nom du passager principal',
    'placeholderLastname': 'NOM',
    'login': 'se connecter',
    'loginFailed': 'La connexion a échoué, merci de vérifier vos informations et de réessayer',
    'login_by_scan': 'Veuillez vous connecter en scannant votre carte pour continuer',
    'step': 'Étape',
    'find_barcode': 'Trouvez le code-barres sur votre carte de navire',
    'scan_barcode': 'Scannez-le sous l\'écran',
    'return_to_home': 'Retour à l\'accueil',
    'error_empty_fields': 'Veuillez vous assurer de remplir tous les champs.',
    'account_nr': 'Numéro de compte',
    'cabin_nr': 'Numéro de cabine',
    'pin_nr': '',
    'change_pin': '',
    'new_pin': '',
    'pin_length_error': '',
    'pin_change_info': '',
    'new_pin_length': '',
    'error_pin_change': '',
    'confirm': 'Confirmer',
    'back': 'Retour',
    'loginFailedRetina': 'La connexion a échoué. Merci de vous rendre à la réception.',
    'login_success': 'Vous êtes connecté en tant que :',
    'redirect_dashboard': 'La page vous redirigera vers le tableau de bord dans un instant',
    'redirect_click_dashboard': 'Si la redirection ne se fait pas automatiquement, veuillez',
    'disableautocentering': 'Désactiver le centrage automatique',
    'hideweather': 'Masquer la météo',
    'hide_ship_names': 'Masquer les noms des navires',
    'hide_fleet': 'Masquer la flotte',
    'no_gps_data': 'Les données GPS n\'ont pas pu être récupérées.',
    'tracker': 'Traçeur du navire',
    'selected_ship': 'Navire sélectionné',
    'trackerweatherheading': 'Météo actuelle',
    'musement_activity_duration': 'Durée : ',
    'musement_activity_price': 'Prix :',
    'musement_activity_from': 'Depuis',
    'musement_activity_language': 'Langue',
    'musement_activity_languages': 'Langues :',
    'musement_activity_do_this_because': 'A faire car',
    'musement_activity_what_to_expect': 'Ce qui vous attend',
    'musement_activity_where': 'Où',
    'musement_activity_meeting_point': 'Point de rendez-vous :',
    'musement_activity_what_is_included': 'Ce qui est inclus',
    'musement_activity_what_is_not_included': 'Ce qui n\'est pas inclus',
    'musement_activity_what_to_remember': 'A retenir',
    'other_currencies_available': 'D\'autres devises sont disponibles. Veuillez noter qu\'une fois que vous avez effectué un paiement à bord, la devise choisie ne peut pas être modifiée.',
    'total_charges': 'Total des frais',
    'department': 'Département',
    'charges': 'Frais',
    'no_charges': 'Aucun débit actuellement sur votre compte',
    'discount': 'Remise',
    'problem_cabin_label': 'Cabine :',
    'problem_category_label': 'Catégorie de problème :',
    'problem_description_label': 'Description du problème :',
    'problem_description_placeholder': 'Décrivez votre problème ici',
    'problem_submit_label': 'Soumettre le problème',
    'tile_add_problem': 'Signaler un problème',
    'tile_problem_tracking': 'Suivi des problèmes',
    'feedback_thank_you_message': 'Merci d’avoir pris le temps de nous transmettre votre retour.',
    'submitFeedback': 'Soumettre',
    'feedback_error_message': 'Votre retour ne peut pas être complété, veuillez contacter l\'équipe concernée.',
    'feedback_termsandconditions_must_be_accepted': 'Veuillez accepter les termes et conditions pour continuer.',
    'yes': 'Oui',
    'no': 'Non',
    'mandatory_answer': 'Ce champ est obligatoire',
    'feedback_please_select': 'Merci de sélectionner',
    'feedback_textarea_placeholder': 'Limite de 250 caractères',
    'feedback_textinput_placeholder': 'Limite de 50 caractères',
    'seanet_vod_fetch_error': 'Aucun titre VOD n\'a été trouvé dans la langue sélectionnée.',
    'retry_all_languages': 'Réessayer toutes les langues',
    'genres': 'catégories',
    'error_fetching_content': 'Erreur dans la recherche du contenu',
    'play': 'lecture',
    'run_time': 'durée d\'exécution',
    'summary': 'résumé',
    'actors': 'acteurs',
    'directed_by': 'Dirigé par',
    'no_spa_available': 'Nous sommes désolés, il n\'y a pas de traitements de spa disponibles.',
    'spa_justtoknow': 'Pour votre information',
    'spa_price': 'Tarifs du spa',
    'spa_duration': 'Durée du spa',
    'watchlistAdd': 'Ajouter à la liste de suivi',
    'watchlist': 'Liste des excursions consultées',
    'movies': 'films',
    'series': 'série',
    'weather-not-available': 'météo non disponible',
    'weather_future_destinations_soon': 'Les prévisions pour les futures destinations seront bientôt disponibles',
    'monday': 'lundi',
    'tuesday': 'mardi',
    'wednesday': 'mercredi',
    'thursday': 'jeudi',
    'friday': 'vendredi',
    'saturday': 'samedi',
    'sunday': 'dimanche',
    'child': 'enfant',
    'adult': 'adulte',
    'passenger_status_MinimumAge': 'La personne est en dessous de l\'âge minimum',
    'passenger_status_MaximumAge': 'La personne est au dessus de l\'âge maximum',
    'passenger_status_AlreadyBooked': 'Déjà réservé',
    'passenger_status_LastCruiseDay': 'Dernier jour de croisière',
    'passenger_status_FirstCruiseDay': 'Premier jour de croisière',
    'passenger_status_NoPriceAvailable': 'Pas de prix disponible',
    'passenger_status_TimeOverlapWithOtherBooking': 'Conflit d’horaire avec une autre réservation',
    'passenger_status_TimeOverlapWithOtherCartEntry': 'Conflit d’horaire avec une autre activité',
  },
  'nl': {
    'excursion_update_basket': 'Winkelwagen bijwerken',
    'excursion_error_no_adult_on_excursion': 'Volwassenen moeten kinderen/baby\'s begeleiden',
    'excursion_remove_from_basket': 'Verwijderden uit winkelwagen',
    'excursion_add_to_basket': 'Aan winkelwagen toevoegen.',
    'excursion_choose_date_label': 'Kies een datum om de beschikbaarheid en prijzen van passagiers te krijgen',
    'please_select': 'Selecteer',
    'excursion_no_available_dates': 'Het spijt ons. Er zijn geen beschikbare data voor deze excursie voor uw boeking',
    'excursion_who_is_traveling': 'Wie gaat er mee op de excursie?',
    'total_price': 'Totaalprijs',
    'excursion_amend_button': 'Excursie wijzigen',
    'excursion_cost_label': 'Kosten excursie:',
    'basket_header': 'Winkelwagen',
    'basket_empty': 'Er zijn geen excursies in uw winkelwagen',
    'return_to': 'Terug naar',
    'home': 'Home',
    'cruises_overview_nights_on': 'nachten op',
    'show_prices_in': 'Prijzen weergeven',
    'day': 'Dag',
    'view_more': 'meer bekijken',
    'basket': 'Winkelwagen',
    'vod-language': 'VOD-taal',
    'logout': 'Uitloggen',
    'book_now': 'Boek nu',
    'itinerary_flight_number': 'Vluchtnummer:',
    'choose_language_label': 'Kies taal:',
    'location': 'Locatie',
    'times': 'Tijden',
    'elapsedTime': 'Tijd gespeeld',
    'time': 'Tijd',
    'hour': 'uur',
    'hours': 'uren',
    'more_details': 'Meer details',
    'per_adult': 'per volwassene',
    'per_child': 'per kind',
    'port_from': 'van',
    'ship_times_in_port': ' waar het schip in de haven ligt',
    'points_of_interest': 'Bezienswaardigheden',
    'please_note': 'Let Op',
    'book_experience': 'Boekervaring',
    'duration': 'Duur',
    'key_facts': 'Belangrijkste feiten',
    'about_the_experience': 'Over de ervaring',
    'on_the_way': 'Onderweg',
    'all': 'Alle',
    '2h_or_less': '2 uur of minder',
    '5h_or_more': '5 uur of meer',
    'experiences_from': 'Ervaringen van',
    'time_in_port': 'Tijd in de haven',
    'experience_type': 'Type ervaring',
    'filter_by': 'Filteren op',
    'clear': 'Weg',
    'contact_shore_ex_manager': 'Neem contact op met de Shore Ex Manager aan boord',
    'sold_out': 'Uitverkocht',
    'contact_team': 'Contact the onboard team for latest availability',
    'vod-language-set-to': 'U bekijkt momenteel VOD-titels die beschikbaar zijn in',
    'select_pref_lang': 'Selecteer de taal van uw voorkeur uit de volgende opties',
    'save': 'Opslaan',
    'close': 'Sluiten',
    'weather-at-sea': 'We zijn vandaag op zee, kom alsjeblieft terug als we de volgende keer in de haven zijn.',
    'weather_today': 'Vandaag',
    'weather_current_conditions': 'Actuele Omstandigheden',
    'feelslike': 'Voelt als',
    'humidity': 'Vochtigheid',
    'wind': 'Wind',
    'weather_pressure': 'Druk',
    'weather_forecast': 'Weersvoorspelling',
    'weather_forecast_not_yet_available': 'Weersvoorspelling nog niet beschikbaar',
    'synopsis': 'Samenvatting',
    'temperature': 'Temperatuur',
    'feels_like': 'Voelt als',
    'date': 'Datum',
    'arrives': 'Komt aan',
    'all_on_board': 'Alles aan boord',
    'departs': 'Vertrekt',
    'currency': 'Valuta',
    'language': 'Taal',
    'name_of_pier': 'Naam van de pier',
    'ships_local_agent': 'Lokale agent van het schip',
    'gangway': 'Gangpad',
    'weather_unavailable': 'Weersinformatie is momenteel niet beschikbaar',
    'all_aboard_times': 'Alles aan boord',
    'port_information': 'Belangrijke informatie',
    'no_activity_available': 'Sorry, er zijn geen activiteiten beschikbaar',
    'no_activities_available': 'Er zijn (nog) geen activiteiten beschikbaar',
    'number_of_persons': 'Aantal personen',
    'no_timeslots': 'Sorry, er zijn geen tijdsloten beschikbaar voor de geselecteerde dag, neem contact op met het betreffende team aan boord',
    'please_wait': 'Gelieve te wachten...',
    'book_not_complete': 'De boeking kan niet worden voltooid, neem contact op met het betreffende team',
    'basket_accept_conditions': 'Accepteer voorwaarden',
    'book_success': 'succesvol geboekt',
    'book_reference_info': 'Uw boekingsreferentienummer is ',
    'book_additional_info': 'U kunt deze boeking bekijken onder \'Mijn boekingen\' op de startpagina.',
    'basket_email_error': 'Vul je e-mailadres in',
    'basket_email_missmatch': 'E-mailadressen moeten overeenkomen',
    'basket_tc_error': 'Accepteer de algemene voorwaarden die hieronder worden vermeld, om door te gaan',
    'basket_total_cost': 'Totale kosten:',
    'basket_contact_details': 'Contactgegevens',
    'basket_email': 'E-mailadres:',
    'basket_confirm_email': 'Bevestig e-mailadres:',
    'basket_mobile_number_label': 'Mobiel nummer:',
    'basket_mobile_number_tip': 'Voer een mobiel nummer in als u dat heeft, zodat we u op de hoogte kunnen houden terwijl u op vakantie bent',
    'basket_payment_label': 'Selecteer de betaalmethode van uw voorkeur:',
    'basket_payment_card': 'Kaart',
    'basket_payment_cash': 'Contant',
    'basket_payment_tip': 'Dit helpt wanneer we contact met u opnemen om uw reservering te voltooien',
    'basket_continue': 'Doorgaan',
    'confirmation_thank_you_card': 'Bedankt voor het reserveren van uw excursie. Wij bellen u 4 uur na aankomst (tussen 09:00 en 20:00 uur) om uw boeking te bevestigen en de betaling te innen.',
    'confirmation_thank_you_cash': 'Bedankt voor het reserveren van uw excursie. UwCorendon/ Stip Reizen-vertegenwoordiger neemt eenmaal ter plaatse contact met u op om uw boeking te bevestigen en contante betalingen te innen.',
    'confirmation_header': 'Alles is gereserveerd!',
    'confirmation_cruise_excursion_text': 'Bedankt voor het boeken van uw cruise-excursie. De getoonde prijs wordt automatisch afgeschreven van uw cruise-account en tickets worden aan boord van uw schip verstrekt.',
    'confirmation_payment_method': 'Betaalmethode:',
    'confirmation_booking_reference': 'Referentie boeking:',
    'confirmation_email': 'E-mail:',
    'confirmation_mobile_number': 'Mobiel nummer:',
    'confirmation_lead_passenger': 'Hoofdpassagier:',
    'confirmation_your_excursions': 'Uw excursies',
    'confirmation_total_cost': 'Totale kosten:',
    'confirmation_my_excursions_pretext': 'U kunt al uw reserveringen op elk moment bekijken onder',
    'confirmation_my_excursions': 'Mijn excursies',
    'confirmation_excursion_cost': 'Kosten excursie:',
    'no_events': 'Geen evenementen gevonden',
    'placeholderKeyword': 'Trefwoord',
    'searchNoResult': 'Sorry, maar we hebben geen resultaten voor uw zoekopdracht',
    'at_sea': 'op zee',
    'technical_data': 'Technische gegevens',
    'timetable_start': 'Start',
    'timetable_end': 'Einde',
    'timetable_title': 'Titel',
    'timetable_deck': 'Locatie',
    'timetable_category': 'Categorie',
    'timetable_location': 'Locatie info',
    'meeting_time': 'Trefpunt',
    'departure_time': 'Vertrektijd ',
    'experience': 'Ervaring',
    'bus_or_group': 'Bus/Groep',
    'meeting_location': 'Vergaderlocatie',
    'port': 'Haven',
    'arrival': 'Aankomst',
    'departure': 'Vertrek',
    'no_whereandwhen': 'Geen locaties gevonden',
    'whereandwhen_title': 'Locatie',
    'whereandwhen_deck': 'Dek',
    'whereandwhen_times': 'Tijden',
    'no_restaurants_available': 'Het spijt ons, er zijn geen restaurants beschikbaar',
    'excursion_description_missing': 'Beschrijving ontbreekt',
    'excursion_check_availability_button': 'Beschikbaarheid controleren - inloggen',
    'excursion_reserve_button': 'Excursie reserveren',
    'excursion_available_on_label': 'Beschikbaar op:',
    'excursion_price_label': 'Prijs: ',
    'excursion_basket_updated': 'Uw winkelwagen is bijgewerkt',
    'excursion_go_to_basket_button': 'Ga verder naar uw winkelwagen',
    'excursion_highlights_label': 'Hoogtepunten',
    'excursion_included_label': 'Inbegrepen',
    'excursion_important_information_label': 'Belangrijke informatie',
    'no_excursions_available': 'Het spijt ons dat er geen excursies beschikbaar zijn voor deze boeking/resort',
    'pax_select_error': 'U moet ten minste één passagier selecteren',
    'experience_already_booked': '',
    'hub_book_experience_error': 'De boeking kan niet worden voltooid. Neem contact op met het betreffende boordpersoneel',
    'your_experience': 'Uw ervaring',
    'is_successfully_booked': 'is succesvol geboekt',
    'my_bookings': 'Mijn boekingen',
    'overbooked': 'Te veel passagiers geselecteerd',
    'slots_remaining': 'Beschikbare plaatsen',
    'participants_checkbox': 'Please use the checkbox to select or unselect participants for',
    'no_experiences_available': 'Geen ervaringen beschikbaar, neem contact op met Destination Services',
    'my_excursions_header': 'Mijn excursies',
    'my_excursions_no_excursions': 'Er zijn geen excursies gereserveerd voor deze boeking.',
    'my_excursions_date': 'Datum',
    'my_excursions_title': 'Titel',
    'my_excursions_cost': 'Kosten',
    'tile_my_holiday': 'Mijn vakantie',
    'tile_browse_all_excursions': 'Bekijk alle excursies',
    'itineraryTitle': 'Uw vakantie',
    'tile_itinerary': 'Reisroute',
    'tile_cruise_excursions': 'Cruise Excursies',
    'tile_resort_excursions': 'Resort Excursies',
    'tile_my_excursions': 'Mijn excursies',
    'no_onboard_bookings': 'Er zijn momenteel geen boekingen voor uw account',
    'confirmed': 'Bevestigd',
    'waitlist': 'Wachtlijst',
    'cancelled': 'Geannuleerd',
    'onboard_bookings_title': 'Uw boekingen',
    'from_time': 'Van tijd',
    'to_time': 'Tot tijd',
    'description': 'Omschrijving',
    'excursion_code': 'Ervaring code',
    'view_experiences': 'Bekijk ervaringen',
    'filters': 'Filters',
    'no_events_match_filters': 'Er zijn geen evenementen die aan de filters voldoen',
    'please_change_filters': 'Wijzig of wis de filters om de evenementen te kunnen zien',
    'search': 'Zoeken',
    'search_events': 'Evenementen zoeken',
    'clear_filters': 'Filters wissen',
    'daily_programme': 'Dagelijks programma',
    'hf_login_first_name': 'Voornaam',
    'hf_login_last_name': 'Achternaam',
    'hf_login_dob': 'Geboortedatum',
    'login_date_error': 'Vul de datum in',
    'login_booking_reference_error': 'Voer uw boekingsreferentie in',
    'login_last_name_error': 'Voer de achternaam in van de passagier die de bevestigingsmail heeft ontvangen',
    'reLoginMessageRetina': 'U bent momenteel uitgelogd bij Navigeren en moet zich aanmelden om door te gaan. Gebruik de link om naar de status/inlogpagina te gaan.',
    'click_here': 'klik hier',
    'configuration_missing': 'Configuratie ontbreekt, informeer het personeel hierover.',
    'accessApplication': 'Log asjeblieft in',
    'departureDate': 'Vertrekdatum',
    'bookingReference': 'Referentie boeking',
    'leadPassengerSurname': 'Naam hoofdpassagier',
    'placeholderLastname': 'ACHTERNAAM',
    'login': 'Inloggen',
    'loginFailed': 'Inloggen mislukt, controleer uw gegevens en probeer het opnieuw',
    'login_by_scan': 'Log in door uw kaart te scannen om door te gaan',
    'step': 'Stap',
    'find_barcode': 'Zoek de barcode op uw scheepskaart',
    'scan_barcode': 'Scan het onder het scherm',
    'return_to_home': 'Terug naar startpagina',
    'error_empty_fields': 'Zorg ervoor dat u alle velden invult',
    'account_nr': 'Rekeningnummer',
    'cabin_nr': 'Cabine Nummer',
    'pin_nr': 'Pincode',
    'change_pin': 'Wijzig uw pincode om door te gaan',
    'new_pin': 'Uw nieuwe pincode',
    'pin_length_error': 'Uw pincode moet uit 4 cijfers bestaan',
    'pin_change_info': 'U kunt uw pincode op elk moment wijzigen of resetten via Mijn account.',
    'new_pin_length': 'Zorg ervoor dat uw nieuwe pincode uit 4 cijfers bestaat.',
    'error_pin_change': 'Er is een fout opgetreden bij het wijzigen van uw pincode.',
    'confirm': 'Bevestigen',
    'back': 'Terug',
    'loginFailedRetina': 'Inloggen is mislukt, ga naar de receptie',
    'login_success': 'U bent nu ingelogd als: ',
    'redirect_dashboard': 'De pagina wordt omgeleid om door het dashboard te navigeren in ',
    'redirect_click_dashboard': 'Als de omleiding niet automatisch gebeurt, alstublieft',
    'disableautocentering': 'Automatisch centreren uitschakelen',
    'hideweather': 'Weer verbergen',
    'hide_ship_names': 'Verberg scheepsnamen',
    'hide_fleet': 'Vloot verbergen',
    'no_gps_data': 'GPS-gegevens konden niet worden opgehaald.',
    'tracker': 'Schip Tracker',
    'selected_ship': 'Geselecteerd schip',
    'trackerweatherheading': 'Huidige weer',
    'musement_activity_duration': 'Duur:',
    'musement_activity_price': 'Prijs:',
    'musement_activity_from': 'van',
    'musement_activity_language': 'Taal:',
    'musement_activity_languages': 'Talen:',
    'musement_activity_do_this_because': 'Doe dit omdat',
    'musement_activity_what_to_expect': 'Wat u kunt verwachten',
    'musement_activity_where': 'Waar',
    'musement_activity_meeting_point': 'Trefpunt:',
    'musement_activity_what_is_included': 'Wat is inbegrepen',
    'musement_activity_what_is_not_included': 'Wat niet is inbegrepen',
    'musement_activity_what_to_remember': 'Wat niet te vergeten',
    'other_currencies_available': 'Andere settelmentmunten zijn beschikbaar. Andere settelmentmunten zijn beschikbaar. Let op, zodra uw eerste betaling betalingen aan boord hebt geregeld, kan de gekozen afrekenvaluta niet meer worden gewijzigd.',
    'total_charges': 'Totale kosten',
    'department': 'Afdeling',
    'charges': 'Kosten',
    'no_charges': 'Er worden momenteel geen kosten in rekening gebracht op uw account',
    'discount': 'Korting',
    'problem_cabin_label': 'Hut:',
    'problem_category_label': 'Probleem categorie:',
    'problem_description_label': 'Beschrijving van het probleem:',
    'problem_description_placeholder': 'Beschrijf het probleem hier',
    'problem_submit_label': 'Probleem indienen',
    'tile_add_problem': 'Meld een probleem',
    'tile_problem_tracking': 'Problemen opsporen',
    'feedback_thank_you_message': 'Bedankt dat je de tijd hebt genomen om feedback te geven.',
    'submitFeedback': 'Verzenden',
    'feedback_error_message': 'De feedback kan niet worden voltooid, neem contact op met het relevante team',
    'feedback_termsandconditions_must_be_accepted': 'Accepteer de algemene voorwaarden om de gegevens in te dienen.',
    'yes': 'Ja',
    'no': 'Nee',
    'mandatory_answer': 'Dit veld is verplicht',
    'feedback_please_select': 'Selecteer',
    'feedback_textarea_placeholder': 'Limiet van 250 tekens',
    'feedback_textinput_placeholder': 'Limiet van 50 tekens',
    'seanet_vod_fetch_error': 'Er zijn geen VOD-titels gevonden in de door u geselecteerde taal.',
    'retry_all_languages': 'Alle talen opnieuw proberen',
    'genres': 'Genres',
    'error_fetching_content': 'Fout bij het ophalen van inhoud',
    'play': 'Afspelen',
    'run_time': 'Looptijd',
    'summary': 'Samenvatting',
    'actors': 'Acteurs',
    'directed_by': 'Geregisseerd door',
    'no_spa_available': 'Het spijt ons dat er geen spa-behandelingen beschikbaar zijn',
    'spa_justtoknow': 'Het is maar dat je het weet',
    'spa_price': 'Prijs',
    'spa_duration': 'Duur',
    'watchlistAdd': 'Toevoegen aan favorietenlijst',
    'watchlist': 'Mijn kijklijst',
    'movies': 'Films',
    'series': 'Box-set',
    'weather-not-available': 'Sorry, het weer kan niet geladen worden',
    'weather_future_destinations_soon': 'Weersvoorspelling voor toekomstige bestemmingen is binnenkort beschikbaar',
    'monday': 'Maandag',
    'tuesday': 'Dinsdag',
    'wednesday': 'Woensdag',
    'thursday': 'Donderdag',
    'friday': 'Vrijdag',
    'saturday': 'Zaterdag',
    'sunday': 'Zondag',
    'child': 'Kind',
    'adult': 'Volwassene',
    'passenger_status_MinimumAge': 'Persoon is jonger dan de minimumleeftijd',
    'passenger_status_MaximumAge': 'Persoon is ouder dan de maximumleeftijd',
    'passenger_status_AlreadyBooked': 'Al geboekt',
    'passenger_status_LastCruiseDay': 'Laatste dag van de cruise',
    'passenger_status_FirstCruiseDay': 'Eerste dag van de cruise',
    'passenger_status_NoPriceAvailable': 'Geen prijs beschikbaar',
    'passenger_status_TimeOverlapWithOtherBooking': 'Overlapping van tijd met een andere boeking',
    'passenger_status_TimeOverlapWithOtherCartEntry': 'Tijdsoverlap met een ander planner-item',
  },
}
